import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Contact, ContactField, Cryptocoin } from "@models";
import { ContactService } from "@main-services/contact.service";
import { ContactFieldService } from "@modules/main/components/step-summary/sending-modal/sending-recipient/services/contact-field.service";

@Component({
	selector: "recently-used-recipients",
	templateUrl: "./recently-used-recipients.component.html",
	providers: [ContactFieldService],
	standalone: false
})
export class RecentlyUsedRecipientsComponent implements OnInit {
	public recentFields: ContactField[];
	@Input() asset: Cryptocoin;
	@Output() recentContactSelected: EventEmitter<ContactField> = new EventEmitter<ContactField>();

	constructor(
		private contactService: ContactService,
		private contactFieldService: ContactFieldService
	) {}

	ngOnInit(): void {
		this.recentFields = this.contactFieldService.getRecentContactFields(this.asset);
	}
	public selectRecent(field: ContactField): void {
		this.recentContactSelected.emit(field);
	}

	public getRecentContactDescription(field: ContactField): string {
		return this.contactFieldService.getRecentContactDescription(field);
	}

	public matchingContact(field: ContactField): Contact[] {
		return this.contactFieldService.matchingContact(field);
	}

	public showDeletedContactName(field: ContactField): boolean {
		return field.getName() && this.isRelatedContactDeleted(field) && !field.isDeleted();
	}

	public isRelatedContactDeleted(c: ContactField): boolean {
		if (c.isDeleted()) {
			return !c.isDeleted();
		}

		const contacts = this.contactService.contacts.filter((contact) => !contact.isDeleted());
		return contacts.some((contact) =>
			contact
				.getFields()
				.some(
					(field) => field.getValue() === c.getValue() && field.getDestinationTag() === c.getDestinationTag()
				)
		);
	}

	public getContactByField(field: ContactField): Contact {
		return this.contactService.findByContactField(field);
	}

	public showContactName(field: ContactField): boolean {
		return !field.getName() && this.contactFieldService.isCurrentContactField(field);
	}
}
